import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export const getCurrentDateString = () => new Date(Date.now()).toISOString();

// Define a type for the slice state
interface VisitState {
  date: string;
  operator: number;
}

// Define the initial state using that type
const initialState: VisitState = {
  date: new Date().toISOString(),
  operator: 0,
};

export const visitSlice = createSlice({
  name: "visit",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload;
    },
    setOperator: (state, action: PayloadAction<number>) => {
      state.operator = action.payload;
    },
  },
});

export const { setDate, setOperator } = visitSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getDate = (state: RootState) => state.visit.date;
export const getOperator = (state: RootState) => state.order.operator;
export default visitSlice.reducer;
